import Grid from '@material-ui/core/Grid'
import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import useValidation from '../../../hooks/Validation/useValidation'
import { useLocation } from '../../../hooks/Location/useLocation'
import ActionButton from '../../ActionButton'
import { ROUTES, sortByName } from '../../../shared/constants'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'
import { CustomSelect } from '../../CustomForm'
const useStyles = makeStyles((theme) => ({
  input: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // marginTop: '20px',
    },
  },
}))

export default function EmployeeFormStep2({ form, setForm, rank, form2, setForm2 }) {
  const { handleValidation, error } = useValidation()
  const { regions, getAllRegion, zones, getAllZone, getAllState, states, districts, getAllDistrict, getAllCity, city, getAllArea, areas, getAllStores, stores } = useLocation()
  let disableButton = true
  const { region, zone, area, state, city: cityNew, district, assignStore } = form
  //console.log('RANK : ', rank)
  //console.log('AREAS : ', stores)
  const classes = useStyles()
  const { handleValidation2, error3 } = useValidation()
  if (Object.values(error3).indexOf('This Field is Required') > -1) {
    disableButton = true
  } else {
    disableButton = false
  }

  // const [rank, setRank] = useState(0)
  // useEffect(() => { }, [region, zone, state, cityNew, district, assignStore])
  useEffect(() => {
    getAllRegion()
    if (region) {
      console.log("zones", getAllZone({ region: region }))
    }
    if (zone) {
      getAllState({ region: region, zone: zone })
    }
    if (state) {
      getAllDistrict({
        region: region,
        zone: zone,
        state: state,
      })
    }
    if (district) {
      getAllCity({ region: region, zone: zone, state: state, district: district })
    }

    if (city) {
      getAllArea({
        region: region,
        zone: zone,
        state: state,
        district: district,
        city: cityNew,
      })
    }
    if (area) {
      getAllStores({
        region: region,
        zone: zone,
        state: state,
        city: cityNew,
        district: district,
        area: area,
      })
    }
  }, [region, zone, state, cityNew, district, area])

  const inputValues = [
    {
      label: 'Region',
      value: region,
      name: 'region',
      noDisplay: !rank,
      options: sortByName(regions),
      fieldName: 'name',
      fieldValue: '_id',
    },
    {
      label: 'Zone',
      value: zone,
      name: 'zone',
      noDisplay: !rank || rank === 1,
      options: sortByName(zones),
      fieldName: 'name',
      fieldValue: '_id',
    },
    {
      label: 'State',
      value: state,
      name: 'state',
      noDisplay: !rank || rank === 1 || rank === 2,
      options: sortByName(states),
      fieldName: 'name',
      fieldValue: '_id',
    },

    {
      label: 'District',
      value: district,
      name: 'district',
      noDisplay: !rank || rank === 1 || rank === 2 || rank === 3,
      options: sortByName(districts),
      fieldName: 'name',
      fieldValue: '_id',
    },

    {
      label: 'City',
      value: cityNew,
      name: 'city',
      noDisplay: !rank || rank === 1 || rank === 2 || rank === 3 || rank === 4,
      options: sortByName(city),
      fieldName: 'name',
      fieldValue: '_id',
    },
    {
      label: 'Area',
      value: area,
      name: 'area',
      noDisplay: !rank || rank === 1 || rank === 2 || rank === 3 || rank === 4 || rank === 5,
      options: sortByName(areas),
      fieldName: 'name',
      fieldValue: '_id',
    },
    {
      label: 'Assign Store',
      value: assignStore,
      name: 'assignStore',
      noDisplay: !rank || rank === 1 || rank === 2 || rank === 3 || rank === 4 || rank === 5,
      options: sortByName(stores),
      fieldName: 'name',
      fieldValue: '_id',
    },
  ]

  return (
    <Grid lg={12} container>
      <Grid item lg={4}>
        <CustomSelect label="Choose Rank" form={form2} setForm={setForm2} options={[1, 2, 3, 4, 5, 6]} name="rank" value={rank} />
      </Grid>
      <CustomAddForm state={form} setState={setForm} data={inputValues} />
    </Grid>
  )
}
